<header class="main-header">
    <a href="" class="logo">
        <span class="logo-mini"><b>sm<span class="logo-o-wrap">o<span class="logo-hash">#</span></span></b></span>
        <img src="./assets/images/logo-green.svg" class="logo-image" alt="Logotipo do SMOCipa">
    </a>

    <nav class="navbar navbar-static-top">
        <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
            <i class="fas fa-bars"></i>
        </a>

        <div class="navbar-custom-menu">
            <ul class="nav navbar-nav">
                <ng-container *ngIf="!isAnonymous">
                    <li class="dropdown notifications-menu academy-indicator-menu">
                        <a href="#" class="dropdown-toggle" data-toggle="dropdown" (click)="$event.preventDefault(); refreshActiveElectionCount()">
                            <i class="fa fa-users"></i>
                            <span class="label label-success">{{ activeElectionCount }}</span>
                        </a>
                        <ul class="dropdown-menu">
                            <li class="header">Você possui <b>{{ activeElectionCount }}</b> eleições ativas no momento.</li>
                            <li class="footer"><a [routerLink]="'/eleicoes'">Ver eleições ativas</a></li>
                        </ul>
                    </li>

                    <li class="dropdown user user-menu">
                        <a href="#" class="-toggle" data-toggle="" data-izimodal-open="#modal_mudar_estabelecimento">
                            <img src="./assets/images/user.png" class="user-image" alt="Imagem do usuário">
                            <span class="hidden-xs">{{ username }}</span>
                        </a>
                    </li>
                </ng-container>

                <li>
                    <a href="#" data-toggle="control-sidebar" (click)="$event.preventDefault(); logout()">
                        <i class="fa fa-sign-out-alt"></i>
                    </a>
                </li>
            </ul>
        </div>
    </nav>
</header>
